import styled from 'styled-components'

import { ReactComponent as TitleSvg } from 'resources/images/names.svg'
import { ReactComponent as MonogramSvg } from 'resources/images/monogram.svg'
import { BREAKPOINTS } from 'resources/constants'

export const NavbarWrapper = styled.nav`
	background-color: rgba(255, 255, 255, 0.9);
	padding: 10px;
	font-size: 0.825rem;
	box-shadow: 0 0px 10px 0px rgba(0, 0, 0, 0.2);
	font-family: 'Trajan Pro', sans-serif;

	.navbar-toggler {
		border: none;
		color: black;

		&:focus {
			box-shadow: none;
		}
	}
`

export const Monogram = styled(MonogramSvg)`
	fill: black;
	height: 30px;
	width: auto;
	margin-right: 20px;
`

export const TitleImage = styled(TitleSvg)`
	fill: black;
	height: 30px;
	width: auto;
`

export const FlagsContainer = styled.div`
	@media screen and (min-width: ${BREAKPOINTS.lg}) {
		margin-left: 20px;
	}
`

export const FlagWrapper = styled.a`
	font-size: 24px;
	color: inherit;
	display: inline-block;
	opacity: ${(props) => (props.active ? 1 : 0.5)};
	padding: 0;
	border: none;
	background: none;
	margin: 0 5px;
	text-decoration: none;
	transition: all 0.3s ease-in-out;

	&:hover {
		opacity: 0.7;
	}
`
